import { useMemo } from "react";
import { useAuth } from "@/auth/AuthProvider";
import { BaseListView } from "@/base";
import { submissionsListView } from "@/pages/submissions/submissionsListView";

// The brokerage's own submissions (BRK-S034): the portal's working home for
// the quoting flow. Own-scoped server-side; the SPA only calls /api/broker/**.
//
// A BaseListView page (BRK-S254). The list, its header, search, filters, sort,
// paging and states are `submissionsListView`.

export function SubmissionsPage() {
  const { authedRequest } = useAuth();
  const def = useMemo(
    () => submissionsListView({ request: authedRequest }),
    [authedRequest],
  );
  return <BaseListView def={def} />;
}
